import React from "react";
import PropTypes from "prop-types";
import {ControlLabel, FormGroup} from "react-bootstrap";
import Box from "../../component/Box/Box";
import Notify from "../../services/Notify";
import EpcDistanceService from "./EpcDistanceService";
import AxisSelector from "./AxisSelector";
import MapSelector from "../MapSelector";
import FormButtons from "../../component/Form/FormButtons";

class EpcDistanceForm extends React.Component {

  service = new EpcDistanceService();

  constructor(props) {
    super(props);
    this.state = {};
  }

  submitForm() {
    const entity = {
      axis: this.axis,
      map: {id: this.mapId},
      centimeters: this.centimeters.value
    };

    this.service.save(entity).then(
        (data) => {
          console.log('EPC: ', entity);
          Notify.success('EPC gerado: ' + data.value);
        },
        (error) => Notify.error('Falha ao salvar entidade:', error));
  }

  render() {
    return (
        <div>
          <form ref={form => (this.form = form)} onSubmit={event => {
            event.preventDefault();
            this.submitForm()
          }}>

            <Box info>
              <AxisSelector setValue={axis => this.axis = axis}/>

              <FormGroup>
                <ControlLabel>Distancia</ControlLabel>
                <input type="text" className="form-control" placeholder="Distancia em centimetros"
                       required
                       name="distance"
                       ref={
                         distance => this.centimeters = distance
                       }/>
              </FormGroup>

              <MapSelector setValue={mapId => this.mapId = mapId}/>

              <FormButtons history={this.props.history}/>
            </Box>
          </form>
        </div>);
  }
}

EpcDistanceForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default EpcDistanceForm;



// WEBPACK FOOTER //
// ./src/map/epc-distance/EpcDistanceForm.js